import Category from "./Category";
import ShopifyProduct from "./ShopifyProduct";
import Pluralize from 'pluralize';

export default class CategoryMapping {

    get category_object(){
        return this.subcategory ?
            { title: this.category == this.subcategory ? this.category : `${this.category} - ${this.subcategory}`, category: this.category, subcategory: this.subcategory } :
            { title: 'Not Set', category: null, subcategory: null };
    }

    set category_object(value){
        this.category = value.category;
        this.subcategory = value.subcategory;
    }

    toData(){
        return {
            field: this.field,
            value: this.value,
            category: this.category,
            subcategory: this.subcategory,
            display_state: this.display_state
        }
    }

    static fromData(category_mapping_data){
        let instance = new CategoryMapping();
        instance.field = category_mapping_data.field;
        instance.value = category_mapping_data.value;
        instance.category = category_mapping_data.category;
        instance.subcategory = category_mapping_data.subcategory;
        instance.display_state = category_mapping_data.display_state;
        return instance;
    }

    static newDefault(potential_site) {
        let instance = new CategoryMapping();
        instance.field = "product_type",
        instance.value = potential_site.product_types[0],
        instance.category = Category.categories[0].name;
        instance.subcategory = this.category;
        instance.display_state = ShopifyProduct.DisplayState.NOT_SET;
        return instance;
    }

    static newEmpty(field, value) {
        let instance = new CategoryMapping();
        instance.field = field;
        instance.value = value;

        let normalisedValue = Pluralize(value.toLowerCase());

        for(let category of Category.categories){
            let normalisedCategory = Pluralize(category.name.toLowerCase());
            for(let subcategory of category.subcategories){
                let normalisedSubcategory = Pluralize(subcategory.name.toLowerCase());

                if( normalisedSubcategory == normalisedValue){
                    instance.category = category.name;
                    instance.subcategory = subcategory.name;
                    return instance;
                }
            }
            if(normalisedCategory == normalisedValue){
                instance.category = category.name;
                instance.subcategory = category.name;
            }
        }

        return instance;
    }
}